import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-conditional-filter',
  templateUrl: './conditional-filter.component.html',
  styleUrls: ['./conditional-filter.component.scss']
})
export class ConditionalFilterComponent implements OnInit {
  @Input() public form: FormGroup;

  constructor() {}

  ngOnInit(): void {}
}
